import { Button, Col, Container, Nav, NavLink, Row } from "react-bootstrap";
import { useStore } from "../../stores/store";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import AdminNav from "./adminNav";

export default observer(function AdminDashboard(){

    const {commonStore, userStore} = useStore();

    useEffect(() => {
        if(commonStore.token){
            userStore.getUser().finally(() => commonStore.setAppLoaded());
        } else{
            commonStore.setAppLoaded()
        }
    }, [commonStore, userStore])
    
   if(!commonStore.appLoaded) return <Container><Row> <h1>Loading...</h1></Row></Container>

    return(
        <>
            
            {userStore.isLoggedIn ? (
               
               <AdminNav />
               
            ) : (
               
                <Container><h1>Not logged in</h1></Container>
             
            )}
        </>
        
    )
    
})